var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGreenShield = function SvgGreenShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6BC7A1",
    fillOpacity: 0.2,
    d: "M7 16.945s7-2.8 7-7v-6.9l-7-2.1-7 2.1v6.9c0 4.2 7 7 7 7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6BC7A1",
    d: "M7 14.778s4.666-2.333 4.666-5.833V4.86L7 3.111l-4.667 1.75v4.084c0 3.5 4.667 5.833 4.667 5.833"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E1F4EC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7 6.32v4.083M4.958 8.361h4.083"
  })));
};
export { SvgGreenShield as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNCAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcgMTYuOTQ0NUM3IDE2Ljk0NDUgMTQgMTQuMTQ0NSAxNCA5Ljk0NDQ2VjMuMDQ0NDZMNyAwLjk0NDQ1OEwwIDMuMDQ0NDZWOS45NDQ0NkMwIDE0LjE0NDUgNyAxNi45NDQ1IDcgMTYuOTQ0NVoiIGZpbGw9IiM2QkM3QTEiIGZpbGwtb3BhY2l0eT0iMC4yIi8+CjxwYXRoIGQ9Ik02Ljk5OTY3IDE0Ljc3ODFDNi45OTk2NyAxNC43NzgxIDExLjY2NjMgMTIuNDQ0OCAxMS42NjYzIDguOTQ0NzhWNC44NjE0NUw2Ljk5OTY3IDMuMTExNDVMMi4zMzMwMSA0Ljg2MTQ1VjguOTQ0NzhDMi4zMzMwMSAxMi40NDQ4IDYuOTk5NjcgMTQuNzc4MSA2Ljk5OTY3IDE0Ljc3ODFaIiBmaWxsPSIjNkJDN0ExIi8+CjxwYXRoIGQ9Ik03IDYuMzE5NDZWMTAuNDAyOCIgc3Ryb2tlPSIjRTFGNEVDIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTQuOTU4MDEgOC4zNjE0NUg5LjA0MTM0IiBzdHJva2U9IiNFMUY0RUMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";